/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedSource
 */
export interface PatchedSource {
    /**
     * 
     * @type {number}
     * @memberof PatchedSource
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedSource
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedSource
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PatchedSource
     */
    date?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedSource
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedSource
     */
    dataTypes?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PatchedSource
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedSource
     */
    readonly updatedAt?: Date;
}

/**
 * Check if a given object implements the PatchedSource interface.
 */
export function instanceOfPatchedSource(value: object): value is PatchedSource {
    return true;
}

export function PatchedSourceFromJSON(json: any): PatchedSource {
    return PatchedSourceFromJSONTyped(json, false);
}

export function PatchedSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedSource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'count': json['count'] == null ? undefined : json['count'],
        'dataTypes': json['data_types'] == null ? undefined : json['data_types'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedSourceToJSON(json: any): PatchedSource {
      return PatchedSourceToJSONTyped(json, false);
  }

  export function PatchedSourceToJSONTyped(value?: Omit<PatchedSource, 'id'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'date': value['date'] == null ? undefined : ((value['date'] as any).toISOString().substring(0,10)),
        'count': value['count'],
        'data_types': value['dataTypes'],
    };
}

